import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/de';

const PRIORITY_BADGE = {
  HIGH: { variant: 'danger', label: 'hoch' },
  NORMAL: { variant: 'secondary', label: 'normal' },
  LOW: { variant: 'info', label: 'niedrig' },
};

const STATUS_LABEL = {
  OPEN: 'offen',
  IN_PROGRESS: 'in Arbeit',
  DONE: 'erledigt',
  CANCELLED: 'abgebrochen',
};

const TodoCard = ({
  todo,
  onClaim,
  onComplete,
  onRelease,
  mobile = false,
}) => {
  const me = useSelector((state) => state.auth.username);
  const stripeColor = todo.category?.color || '#6c757d';
  const isMine = todo.assigned_to_username === me;
  const priority = PRIORITY_BADGE[todo.priority] || PRIORITY_BADGE.NORMAL;

  const dueLabel = todo.due_at
    ? moment(todo.due_at).locale('de').calendar()
    : null;

  const primaryAction = (() => {
    if (todo.status === 'DONE') return null;
    if (todo.status === 'OPEN' && !todo.assigned_to_username) {
      return (
        <button
          className={`btn btn-primary ${mobile ? 'btn-lg' : ''}`}
          style={mobile ? { minHeight: 48 } : undefined}
          onClick={() => onClaim?.(todo.id)}
        >
          <i className='fas fa-hand-paper me-2' />
          Übernehmen
        </button>
      );
    }
    if (todo.status === 'IN_PROGRESS' && isMine) {
      return (
        <>
          <button
            className={`btn btn-success ${mobile ? 'btn-lg' : ''}`}
            style={mobile ? { minHeight: 48 } : undefined}
            onClick={() => onComplete?.(todo.id)}
          >
            <i className='fas fa-check me-2' />
            Erledigt
          </button>
          {!mobile && (
            <button
              className='btn btn-outline-secondary ms-2'
              onClick={() => onRelease?.(todo.id)}
            >
              Freigeben
            </button>
          )}
        </>
      );
    }
    if (todo.status === 'IN_PROGRESS') {
      return (
        <button
          className={`btn btn-secondary ${mobile ? 'btn-lg' : ''}`}
          style={mobile ? { minHeight: 48 } : undefined}
          disabled
        >
          übernommen von {todo.assigned_to_username}
        </button>
      );
    }
    return null;
  })();

  return (
    <div
      className={`card mb-2 ${todo.is_overdue ? 'border-danger' : ''}`}
      style={{ borderLeft: `6px solid ${stripeColor}` }}
    >
      <div className='card-body p-3'>
        <div className='d-flex justify-content-between align-items-start'>
          <div className='flex-grow-1 me-2'>
            <h5 className='mb-1'>
              <Link
                to={`/todo/${todo.id}`}
                className='text-decoration-none text-reset'
              >
                {todo.title}
              </Link>
            </h5>
            <div className='small text-muted'>
              <span
                className='badge me-1'
                style={{ backgroundColor: stripeColor }}
              >
                {todo.category?.icon && (
                  <i className={`fas fa-${todo.category.icon} me-1`} />
                )}
                {todo.category?.name}
              </span>
              <span className={`badge bg-${priority.variant} me-1`}>
                {priority.label}
              </span>
              <span className='badge bg-light text-dark me-1'>
                {STATUS_LABEL[todo.status]}
              </span>
              {dueLabel && (
                <span
                  className={`badge me-1 ${todo.is_overdue ? 'bg-danger' : 'bg-warning text-dark'}`}
                >
                  <i className='far fa-clock me-1' />
                  {dueLabel}
                </span>
              )}
              {todo.assigned_to_username && (
                <span className='ms-1'>
                  <i className='fas fa-user me-1' />
                  {todo.assigned_to_username}
                </span>
              )}
            </div>
            {!mobile && todo.description && (
              <p className='mt-2 mb-0 small'>{todo.description}</p>
            )}
          </div>
          <div className='text-end'>{primaryAction}</div>
        </div>
      </div>
    </div>
  );
};

export default TodoCard;
